import { LYNX_TENANT } from '../actionTypes';

const initialState = {
  lynxTenantDetails: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LYNX_TENANT.SUCCESS_LYNX_TENANT_DETAILS:
      return {
        ...state,
        lynxTenantDetails: action.payload?.content,
      };
    default:
      return state;
  }
};
